import { StyledProps } from '@components/3rd-party/mui'
import { Label } from '@components/UI-Components/Label'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { Button, Menu, MenuItem } from '@material-ui/core'
import { strings } from '@stores'
import classNames from 'classnames'
import { useLocalStore, useObserver } from 'mobx-react-lite'
import React from 'react'
import * as css from './ListViewMenu.css'

interface IListViewMenu extends StyledProps {
  style?: any
  values?: any
  label?: any
  cellPadding?: string
  anchorEl?: any
  onMenuClose?: any
  onMenuClick?: any
  onActionClick?: any
  actiontext?: string
  disableAction?: any
}

export const ListViewMenu: React.FunctionComponent<IListViewMenu> = React.memo(
  ({ values, label, cellPadding, onActionClick, actiontext, disableAction }) => {
    const state = useLocalStore(() => ({
      anchorEl: null,
      onMenuClose: () => {
        state.anchorEl = null
      },
      onMenuClick: event => {
        state.anchorEl = event.currentTarget
      }
    }))

    return useObserver(function useHook() {
      const showMenu = onActionClick || (values && values.length > 1)

      return (
        <div className={css.menuContainer}>
          <div
            className={css.dropdownWrapper}
            onClick={showMenu ? event => state.onMenuClick(event) : () => {}}
          >
            <Label
              value={label}
              cellPadding={cellPadding ? cellPadding : '0'}
              cursor={showMenu ? strings.pointer : undefined}
              disabled={disableAction}
            />
            {showMenu ? (
              <div
                className={classNames(css.menuArrow, {
                  [css.openMenu]: Boolean(state.anchorEl)
                })}
              >
                <ArrowDropDownIcon
                  className={css.headerIconSize}
                  classes={{
                    fontSizeLarge: css.headerIconSize
                  }}
                />
              </div>
            ) : null}
          </div>
          <Menu
            id='list-menu'
            anchorEl={state.anchorEl}
            open={Boolean(state.anchorEl)}
            onClose={state.onMenuClose}
            classes={{ paper: css.paperMenu }}
            MenuListProps={{ classes: { root: css.list } }}
          >
            {values.map((menu, index) => {
              return (
                <MenuItem key={index} className={classNames(css.item)} disabled>
                  {menu.label}
                </MenuItem>
              )
            })}
            {onActionClick && (
              <Button
                variant='contained'
                color='primary'
                onClick={onActionClick}
                classes={{ root: css.rootContainer }}
              >
                {actiontext}
              </Button>
            )}
          </Menu>
        </div>
      )
    })
  }
)
